module.exports = "//public.zight.com/packs/media/images/plus-small-f87599579ec0ff7d14e546917170f26a.svg";